'use client'
import { Badge, Flex, Stack } from '@mantine/core'
import { useSession } from 'next-auth/react'
import Image from 'next/image'
//@ts-ignore
import profilePlaceholder from '../../../../../assets/profile-placeholder.png'

import { useTranslations } from 'next-intl'
import { Text } from '../../../../components'

export const Profile = () => {
  const t = useTranslations('Ui.Profile')

  const { data } = useSession()
  return (
    <Stack>
      <Flex gap='xs' align='center' justify='space-between'>
        <Flex gap='xs'>
          <Image
            src={profilePlaceholder}
            alt='profile-placeholder'
            height={50}
            width={50}
            className='h-[50px] w-[50px]'
          />
          <Stack gap='xs'>
            <Text
              c='var(--mantine-color-Neutral-1)'
              className='!font-semibold !text-sm'
            >
              {data?.user?.name}
            </Text>
            <Text c='var(--mantine-color-Neutral-4)' className='!text-xs'>
              {t('view')}
            </Text>
          </Stack>
        </Flex>
        <Badge variant='outline' c='var(--mantine-color-Neutral-0)' p='sm'>
          Gold level
        </Badge>
      </Flex>
    </Stack>
  )
}
